var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/python"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8917 2.16667C7.58333 2.16667 7.90833 4.44167 7.90833 4.44167V6.825H13V7.58333H5.85C5.85 7.58333 2.16667 7.15 2.16667 12.5667C2.16667 17.9833 5.41667 17.7667 5.41667 17.7667H7.36667V15.275C7.36667 15.275 7.25833 12.025 10.5083 12.025H15.8167C15.8167 12.025 18.85 12.025 18.85 9.1V5.2C18.85 5.2 19.2833 2.16667 12.8917 2.16667ZM10.075 3.79167C10.3336 3.79167 10.5816 3.89439 10.7644 4.07724C10.9473 4.26009 11.05 4.50808 11.05 4.76667C11.05 5.02525 10.9473 5.27325 10.7644 5.4561C10.5816 5.63894 10.3336 5.74167 10.075 5.74167C9.81641 5.74167 9.56842 5.63894 9.38557 5.4561C9.20272 5.27325 9.1 5.02525 9.1 4.76667C9.1 4.50808 9.20272 4.26009 9.38557 4.07724C9.56842 3.89439 9.81641 3.79167 10.075 3.79167Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1083 23.8333C18.4167 23.8333 18.0917 21.5583 18.0917 21.5583V19.175H13V18.4167H20.15C20.15 18.4167 23.8333 18.85 23.8333 13.4333C23.8333 8.01667 20.5833 8.23333 20.5833 8.23333H18.6333V10.725C18.6333 10.725 18.7417 13.975 15.4917 13.975H10.1833C10.1833 13.975 7.15 13.975 7.15 16.9V20.8C7.15 20.8 6.71667 23.8333 13.1083 23.8333ZM15.925 22.2083C15.6664 22.2083 15.4184 22.1056 15.2356 21.9228C15.0527 21.7399 14.95 21.4919 14.95 21.2333C14.95 20.9747 15.0527 20.7268 15.2356 20.5439C15.4184 20.3611 15.6664 20.2583 15.925 20.2583C16.1836 20.2583 16.4316 20.3611 16.6144 20.5439C16.7973 20.7268 16.9 20.9747 16.9 21.2333C16.9 21.4919 16.7973 21.7399 16.6144 21.9228C16.4316 22.1056 16.1836 22.2083 15.925 22.2083Z",
    fill: "#FFD43B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPython);
export default __webpack_public_path__ + "static/media/logo-python.5967bde5e45c4b32ca24229e34a3648e.svg";
export { ForwardRef as ReactComponent };